import { runSyncAsUser } from '../utils/exec';

export const enable = (time: number = 60) => {
  runSyncAsUser('./screensaver.sh', ['enable', time]);
};

export const disable = () => {
  runSyncAsUser('./screensaver.sh', ['disable']);
};

let screensaverState = null;

export const set = () => {
  if (screensaverState) {
    enable(screensaverState);
  } else {
    disable();
  }
};

export const update = (config: Object, shouldSet = true) => {
  if (config.screenSaver === screensaverState) return;

  screensaverState = config.screenSaver;
  if (shouldSet) set();
};
